import "core-js/modules/es.function.name";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import useUser from '@sprinx/react-auth/useUser';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import UserAvatar from '../UserAvatar';
import AppBarAction from '../AppBarAction';
/**
 * Akce aplikacniho toolbaru zobrazujici avatar
 */

function AppBarActionUserAvatar(_ref) {
  var path = _ref.path,
      rest = _objectWithoutProperties(_ref, ["path"]);

  var user = useUser();

  var _ref3 = React.createElement(ListItemIcon, null, React.createElement(UserAvatar, {
    margin: "none",
    size: "small",
    human: user
  }));

  return React.createElement(AppBarAction, _extends({
    icon: React.createElement(UserAvatar, {
      human: user
    }),
    label: user.name,
    path: path,
    renderMenuItem: function renderMenuItem(_ref2) {
      var disableInset = _ref2.disableInset,
          label = _ref2.label,
          onClick = _ref2.onClick;
      return React.createElement(MenuItem, {
        onClick: onClick
      }, _ref3, React.createElement(ListItemText, {
        inset: !disableInset,
        primary: label
      }));
    }
  }, rest));
}

AppBarActionUserAvatar.propTypes = {
  /**
   * Cesta pro presmerovani po kliknuti.
   */
  path: PropTypes.string,

  /**
   * Podminene zobrazeni vysledku.
   *
   * Pokud je hodnota `false`, nebo vysledek volani funkce je `false`,
   * komponenta se nebude zobrazovat.
   *
   * Funkce ma format `(showIfContext) => bool`.
   */
  showIf: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.func]),
  // eslint-disable-line react/no-unused-prop-types

  /**
   * Variant zobrazeni.
   *
   * - `none` nezobrazuje se.
   * - `standalone` aplikuje se renderStandalone pokud je definovano, nebo se renderuje IconButton.
   * - `menuItem` aplikuje se renderMenuItem pokud je definovano, nebo se renderuje MenuItem.
   */
  variant: PropTypes.oneOf(['none', 'standalone', 'menuItem'])
};
AppBarActionUserAvatar.defaultProps = {
  path: '/profile',
  showIf: true,
  variant: undefined
};
export default AppBarActionUserAvatar;